// // src/pages/Prospects/Prospects.jsx
// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Paper,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Chip,
//   CircularProgress,
//   TextField,
//   Button,
//   TableContainer
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import api from "../../utils/api";   // ← adjust if your path is different

// export default function Prospects() {
//   const [prospects, setProspects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const navigate = useNavigate();

//   const loadProspects = async () => {
//     setLoading(true);
//     try {
//       const res = await api.get("/leads", {
//         params: {
//           pipeline_stage: "Prospect",   // only show verified & connected leads
//           q: search
//         }
//       });
//       setProspects(res.data.leads || []);
//     } catch (err) {
//       alert("Failed to load prospects");
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadProspects();
//   }, []);

//   // Live search
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       loadProspects();
//     }, 400);
//     return () => clearTimeout(timer);
//   }, [search]);

//   return (
//     <Box sx={{ p: 3 }}>
//            {/* Header */}
//       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
//         <Typography variant="h4" fontWeight="bold">
//           Prospects (Verified Leads)
//         </Typography>

//         <Box sx={{ display: "flex", gap: 2 }}>
//           <TextField
//             size="small"
//             placeholder="Search name / mobile..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//           />
//           <Button variant="contained" onClick={loadProspects}>
//             Refresh
//           </Button>
//         </Box>
//       </Box>

//       {/* Table */}
//       <Paper elevation={3}>
//         <TableContainer sx={{ maxHeight: "78vh" }}>
//           <Table stickyHeader>
//             <TableHead>
//               <TableRow sx={{ backgroundColor: "#e8f5e8" }}>
//                 <TableCell><b>UID</b></TableCell>
//                 <TableCell><b>Name</b></TableCell>
//                 <TableCell><b>Mobile</b></TableCell>
//                 <TableCell><b>Email</b></TableCell>
//                 <TableCell><b>Source</b></TableCell>
//                 <TableCell><b>Assigned To</b></TableCell>
//                 <TableCell><b>Stage</b></TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {loading && (
//                 <TableRow>
//                   <TableCell colSpan={7} align="center">
//                     <CircularProgress />
//                   </TableCell>
//                 </TableRow>
//               )}

//               {!loading && prospects.length === 0 && (
//                 <TableRow>
//                   <TableCell colSpan={7} align="center">
//                     <Typography color="text.secondary">
//                       No prospects yet. When a call is marked "Connected", leads will appear here.
//                     </Typography>
//                   </TableCell>
//                 </TableRow>
//               )}

//               {prospects.map((lead) => (
//                 <TableRow
//                   key={lead.id}
//                   hover
//                   sx={{ cursor: "pointer" }}
//                   onClick={() => navigate(`/leads/${lead.id}`)}
//                 >
//                   <TableCell>{lead.lead_uid}</TableCell>
//                   <TableCell><b>{lead.name}</b></TableCell>
//                   <TableCell>{lead.mobile}</TableCell>
//                   <TableCell>{lead.email || "—"}</TableCell>
//                   <TableCell>
//                     <Chip label={lead.source_name || "Direct"} size="small" color="primary" />
//                   </TableCell>
//                   <TableCell>{lead.assigned_user_name || "Unassigned"}</TableCell>
//                   <TableCell>
//                     <Chip
//                       label={lead.pipeline_stage || "Prospect"}
//                       color="success"
//                       size="small"
//                     />
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </Paper>
//     </Box>
//   );
// }

import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
  Chip,
  CircularProgress,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  Stack
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";

// Define your pipeline stages
const STAGES = [
  { id: "Lead", title: "New Leads", color: "#ff9800" },
  { id: "Prospect", title: "Prospects", color: "#4caf50" },
  { id: "SiteVisit", title: "Site Visit", color: "#2196f3" },
  { id: "Measurement", title: "Measurement", color: "#9c27b0" },
  { id: "Photos", title: "Photos", color: "#00bcd4" },
  { id: "Quotation", title: "Quotation Sent", color: "#ff5722" },
  { id: "Deal", title: "Won", color: "#2e7d32" },
  { id: "Lost", title: "Lost", color: "#d32f2f" }
];

export default function Prospects() {
  const [activeTab, setActiveTab] = useState(1); // Start with "Prospects"
  const [leads, setLeads] = useState({});
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const loadLeads = async () => {
    setLoading(true);
    try {
      const res = await api.get("/leads", { params: { q: search } });
      const data = res.data.leads || [];

      const grouped = {};
      STAGES.forEach(stage => {
        grouped[stage.id] = data.filter(l => l.pipeline_stage === stage.id);
      });
      setLeads(grouped);
    } catch (err) {
      alert("Failed to load pipeline");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLeads();
  }, []);

  // Live search
  useEffect(() => {
    const timer = setTimeout(loadLeads, 500);
    return () => clearTimeout(timer);
  }, [search]);

  const currentStage = STAGES[activeTab];
  const currentLeads = leads[currentStage?.id] || [];

  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Box sx={{ mb: 4, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h4" fontWeight="bold">Sales</Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            size="small"
            placeholder="Search across all stages..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <Button variant="contained" onClick={loadLeads}>Refresh</Button>
        </Box>
      </Box>

      {/* Tabs */}
      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={(e, v) => setActiveTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          {STAGES.map((stage, index) => (
            <Tab
              key={stage.id}
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box
                    sx={{
                      width: 12,
                      height: 12,
                      borderRadius: "50%",
                      backgroundColor: stage.color,
                    }}
                  />
                  {stage.title} ({leads[stage.id]?.length || 0})
                </Box>
              }
            />
          ))}
        </Tabs>
      </Paper>

      {/* Loading */}
      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", my: 8 }}>
          <CircularProgress size={60} />
        </Box>
      )}

      {/* Content */}
      {!loading && (
        <Grid container spacing={3}>
          {currentLeads.length === 0 ? (
            <Grid item xs={12}>
              <Paper sx={{ p: 6, textAlign: "center", background: "#f9f9f9" }}>
                <Typography variant="h6" color="text.secondary">
                  No leads in <strong>{currentStage.title}</strong> stage
                </Typography>
              </Paper>
            </Grid>
          ) : (
            currentLeads.map((lead) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={lead.id}>
                <Card
                  onClick={() => navigate(`/leads/${lead.id}`)}
                  sx={{
                    cursor: "pointer",
                    transition: "0.2s",
                    "&:hover": { transform: "translateY(-4px)", boxShadow: 6 }
                  }}
                >
                  <CardContent>
                    <Typography variant="h6" fontWeight="bold">
                      {lead.name}
                    </Typography>
                    <Typography color="text.secondary">{lead.mobile}</Typography>

                    <Stack direction="row" spacing={1} mt={2} flexWrap="wrap" gap={1}>
                      <Chip label={lead.lead_uid} size="small" />
                      {lead.is_verified === 1 && (
                        <Chip label="Verified" color="success" size="small" />
                      )}
                      <Chip
                        label={lead.source_name || "Direct"}
                        size="small"
                        variant="outlined"
                      />
                    </Stack>

                    {lead.assigned_user_name && (
                      <Typography variant="body2" color="primary" mt={2}>
                        Assigned to: {lead.assigned_user_name}
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))
          )}
        </Grid>
      )}
    </Box>
  );
}